import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {NavbarComponent} from '../../components/navbar/navbar.component';
import {NgForOf, NgIf} from '@angular/common';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatPaginator, MatPaginatorIntl} from '@angular/material/paginator';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {LotsService} from '../../services/lots.service';
import {DatePipe} from '../../pipe/date.pipe';
import {getFrenchPaginatorIntl} from '../../translators/mat-paginator-intl-fr';
import {MatIcon} from '@angular/material/icon';

export interface Lot {
  affairsCount: number;
  name: string;
  registerDate: Date;
}

@Component({
  selector: 'app-lots-list',
  imports: [
    FormsModule,
    MatTableModule,
    MatPaginator,
    MatProgressSpinner,
    NavbarComponent,
    NgForOf,
    NgIf,
    HttpClientModule,
    DatePipe,
    MatIcon,
    RouterLink,
  ],
  templateUrl: './lots-list.component.html',
  styleUrl: './lots-list.component.css',
  providers: [LotsService,  { provide: MatPaginatorIntl, useValue: getFrenchPaginatorIntl() }]
})
export class LotsListComponent implements AfterViewInit, OnInit {
  displayedColumns: string[] = ['name', 'affairsCount', 'registerDate', 'nagivate'];

  dataSource = new MatTableDataSource<Lot>([]);

  public isLoading: boolean = false;
  public searchString: string = '';
  public lotsCount: number = 0;

  private currentLots: Lot[] = [];
  private filtredLots: Lot[] = [];

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private lotsService: LotsService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.fetchLots();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  fetchLots() {
    this.isLoading = true;

    this.lotsService.getAll().subscribe({
      next: (data) => {

        this.dataSource.data = data;
        this.lotsCount = data.length;

        this.currentLots = data;

        if (this.paginator) {
          this.dataSource.paginator = this.paginator;
        }

        this.isLoading = false;
      },
      error: (error) => {
        this.snackBar.open(error.message, 'Fermer', {
          duration: 5000,
        });
        this.isLoading = false;
      }
    });
  }

  updateSearchString(event: any): void {
    if (this.searchString.length >= 1) {
      const searchLower = this.searchString.toLowerCase();
      this.filtredLots = this.currentLots.filter((lot) => {
        const nameMatch = lot.name.toLowerCase().includes(searchLower);
        const date = new Date(lot.registerDate);
        const yearMatch = date.getFullYear().toString().includes(searchLower);
        const monthMatch = date.getMonth().toString().includes(searchLower);
        return nameMatch || yearMatch || monthMatch;
      });
      this.dataSource.data = this.filtredLots;
    } else {
      this.dataSource.data = this.currentLots;
    }
  }

  navigateToAffairs(row: Lot) {
    this.router.navigate(["/affaires", row.name]);
  }
}
